import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  BodyText,
  COLORS,
  SPACING,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';

export const ErrorMessage = ({ minimalStyles = false }) => {
  const { currentBreakpoint } = useBreakpointHelpers();
  const { t } = useLocalizationContext();

  const wrapperStyles = [
    styles.wrapper,
    currentBreakpoint.isMobile ? styles.wrapperMobile : styles.wrapperDesktop,
    minimalStyles && styles.wrapperMinimal,
  ];

  return (
    <View style={wrapperStyles} testID="location-results-error-message">
      <BodyText>{t('general.connection-issue-message')}</BodyText>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    right: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: COLORS.PINK_3,
    textAlign: 'center',
    alignItems: 'center',
    paddingVertical: SPACING.large,
    paddingHorizontal: SPACING.medium,
    borderColor: COLORS.GREEN_1,
  },
  wrapperMinimal: {
    borderTopWidth: 0,
    borderBottomWidth: 0,
  },
  wrapperMobile: {
    bottom: 0,
    borderTopWidth: 1,
  },
  wrapperDesktop: {
    top: 0,
    borderBottomWidth: 1,
  },
});
